import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=6c020a7a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c020a7a')) {
      api.createRecord('6c020a7a', component.options)
    } else {
      api.reload('6c020a7a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=6c020a7a&", function () {
      api.rerender('6c020a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B6wGS5YGi759/JS/comp/childrenage.vue"
export default component.exports